import { useState, MouseEvent } from "react";
import MoreVert from "@material-ui/icons/MoreVert";
import Info from "@material-ui/icons/Info";
import Edit from "@material-ui/icons/Edit";
import IconButton from "@material-ui/core/IconButton";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useTableActionStyles } from "./styles";
// import Link from "@material-ui/core/Link";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { AttendanceLocal } from "../../../../../@types/attendance-local";
import { usePermission } from "../../../../../hooks/usePermission";

type AttendanceLocalListTableActionsProps = {
    slug: AttendanceLocal['slug_unidade'];
}

export default function AttendanceLocalListTableActions({ slug }: AttendanceLocalListTableActionsProps) {
    const { pathname } = useLocation();
    const { classes } = useTableActionStyles();
    const { isAboveCoordenator } = usePermission();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton onClick={handleClick} >
                <MoreVert />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                keepMounted
            >
                <MenuItem
                    component={Link}
                    onClick={handleClose}
                    className={classes.menuItem}
                    to={`${pathname}/${slug}`}
                >
                    <Info htmlColor="#706E7A" />
                    Informações
                </MenuItem>
                {isAboveCoordenator && (
                    <MenuItem
                        component={Link}
                        onClick={handleClose}
                        className={classes.menuItem}
                        to={`${pathname}/${slug}/editar`}
                    >
                        <Edit htmlColor="#706E7A" />
                        Editar
                    </MenuItem>
                )}
            </Menu>
        </>
    );
}